import { useState } from "react";
import { closeModal, Modal } from "risa-oasis-ui_v2";
import CustomRadioButton from "../../../../../../components/customRadioButton/customRadioButton";
import { ModalId } from "../../../../../../../shared/enums/modalId";

export type SortOption = "priority" | "left_pane_display_order";

interface ReorderModalProps {
  currentSort: SortOption;
  onSave: (sortOption: SortOption) => void;
  onClose: () => void;
}

const ReorderModal = (props: ReorderModalProps) => {
  const [selectedSort, setSelectedSort] = useState<SortOption>(
    props.currentSort,
  );

  const handleSave = () => {
    props.onSave(selectedSort);
    closeModal(ModalId.OPTIONS_REORDER_MODAL);
  };

  const handleClose = () => {
    closeModal(ModalId.OPTIONS_REORDER_MODAL);
    props.onClose();
  };

  return (
    <Modal
      dialogId={ModalId.OPTIONS_REORDER_MODAL}
      onSave={handleSave}
      title="Reorder Auth Options"
      saveButtonText="Apply"
      cancelText="Cancel"
      onClose={handleClose}
    >
      <div className="flex flex-col gap-2">
        <div className="text-sm text-gray-600">
          Choose how to sort the auth options:
        </div>
        <div className="mt-2 flex flex-col gap-3">
          <CustomRadioButton
            name="sortOption"
            value="priority"
            checked={selectedSort === "priority"}
            label="Sort by Priority"
            onChange={() => setSelectedSort("priority")}
          />
          <CustomRadioButton
            name="sortOption"
            value="left_pane_display_order"
            checked={selectedSort === "left_pane_display_order"}
            label="Sort by Left Pane Display Order"
            onChange={() => setSelectedSort("left_pane_display_order")}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ReorderModal;
